import React from 'react';
import { Bundle } from '@ali/visualengine';
import {
  getArraySetterSnippet,
  getCnSelectSetter,
  getDataOriginSetterSnippet,
  getMixedSetterSnippet,
  getObjectSetterSnippet,
} from '@/common/manager/setter-snippet';
import { getJSExpressionPrototype } from '@/common/manager/common-style';
import { ParamSelectSetter } from '@/common/setter/param-select-setter';
import { __dataSource__ } from '@/common/util/expr-const';
import { getStatusDataSource } from '@/common/util/prototype-util';
import { DisplayPosition } from '@/type/display-position';
import { createMessageSetters } from '@/common/manager/message';

// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export default Bundle.createPrototype({
  title: '信息提示',
  componentName: 'CnMessage',
  category: '反馈',
  isContainer: false,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  configure: [
    {
      title: '信息配置',
      type: 'group',
      collapsed: false,
      display: 'accordion',
      items: createMessageSetters({
        needMargin: true,
        position: DisplayPosition.message,
      }),
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
  ],
});
